import { useEffect, useState } from "react";
import axios from "axios";
import {
  FiUsers,
  FiHeart,
  FiBarChart2,
  FiFlag,
} from "react-icons/fi";
import UserGrowthChart from "../components/Charts/UserGrowthChart";
import { FaFemale, FaMale } from "react-icons/fa";

export default function Dashboard() {
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({
    totalUsers: 0,
    activeUsers: 0,
    newUsersToday: 0,
    newUsersThisMonth: 0,
    
  });
const[count,setcount]=useState();
  const [recentUsers, setRecentUsers] = useState([]);
  const [userGrowth, setUserGrowth] = useState([]);
  const [activeTab, setActiveTab] = useState("all");
  const currentYear = new Date().getFullYear();
const [selectedYear, setSelectedYear] = useState(currentYear);
const [years] = useState([currentYear, currentYear - 1, currentYear - 2]);


  // Login admin stored in localStorage or decode token

  const adminUser = JSON.parse(localStorage.getItem("adminUser"));
  const adminId = adminUser?.id;
  const token = localStorage.getItem("token");

  useEffect(() => {
    fetchDashboardData(selectedYear);
  }, [selectedYear]);


  const fetchDashboardData = async (year = selectedYear) => {
  try {
    setLoading(true);

    const [analyticsRes, usersRes, growthRes,genderCount] = await Promise.all([
      axios.get('/api/v1/admin/analytics/dashboard'),
      axios.get('/api/v1/admin/users'),
      axios.get(`/api/v1/admin/analytics/users?year=${year}`) ,
      axios.get(`/api/v1/user/getGender`)
      // use param year
    ]);

    if (analyticsRes.data.success) {
      setStats(analyticsRes.data.data);
    }
    if(genderCount.data.success){
setcount(genderCount.data.data);

    }

    if (usersRes.data.success) {
      const users = usersRes.data.data || [];
      setRecentUsers(users.slice(0, 5));
    }

    // <-- FIX: read monthlyGrowth instead of userGrowth
    if (growthRes.data.success) {
      setUserGrowth(growthRes.data.data.monthlyGrowth || []);
   
    }
  } catch (error) {
    console.error("Dashboard Error:", error);
  } finally {
    setLoading(false);
  }
};


  if (loading) {
    return (
      <div className="p-6 flex justify-center items-center h-40">
        <div className="w-10 h-10 border-4 border-gray-200 border-t-[var(--primary-solid)] rounded-full animate-spin" />
      </div>
    );
  }




  const filteredUsers =
    activeTab === "verified"
      ? recentUsers.filter((user) => user.isProfileCompleted)
      : recentUsers;

  return (
    <div className="p-6 min-h-screen bg-white text-[var(--black-text)]">

      {/* HEADER */}
      <div className="flex items-center justify-between mb-8">
        <h1 className="text-3xl font-bold">Dashboard Overview</h1>
      </div>

      {/* TOP STATS */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-10">

        {/* Total Users */}
        <div className="bg-gradient-to-br from-blue-500/10 to-blue-500/5 border-2 border-blue-500/20 rounded-xl p-6 shadow-lg">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-blue-400 uppercase tracking-wider">
                Total Users
              </p>
              <p className="text-3xl font-bold text-blue-400">
                {stats.totalUsers}
              </p>
            </div>
            <div className="text-4xl text-blue-400">
              <FiUsers />
            </div>
          </div>
        </div>

        {/* Active Users */}
        <div className="bg-gradient-to-br from-green-500/10 to-green-500/5 border-2 border-green-500/20 rounded-xl p-6 shadow-lg">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-green-400 uppercase tracking-wider">
                Active Users
              </p>
              <p className="text-3xl font-bold text-green-400">
                {stats.activeUsers}
              </p>
            </div>
            <div className="text-4xl text-green-400">
              <FiHeart />
            </div>
          </div>
        </div>

        {/* Male Users */}
        <div className="bg-gradient-to-br from-purple-500/10 to-purple-500/5 border-2 border-purple-500/20 rounded-xl p-6 shadow-lg">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-purple-400 uppercase tracking-wider">
                Male Users
              </p>
              <p className="text-3xl font-bold text-purple-400">
                {count?.male || 0}
              </p>
            </div>
            <div className="text-4xl text-purple-400">
              <FaMale />
            </div>
          </div>
        </div>

        {/* Female Users */}
        <div className="bg-gradient-to-br from-pink-500/10 to-pink-500/5 border-2 border-pink-500/20 rounded-xl p-6 shadow-lg">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-pink-400 uppercase tracking-wider">
                Female Users
              </p>
              <p className="text-3xl font-bold text-pink-400">
                {count?.female || 0}
              </p>
            </div>
            <div className="text-4xl text-pink-400">
              <FaFemale />
            </div>
          </div>
        </div>
      </div>

      {/* USER GROWTH + ACTIVITY */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">

        {/* User Growth */}
        <div className="p-6 rounded-lg bg-white border-2 border-gray-200 shadow-sm">
          <div className="flex justify-between items-center mb-4">
    <h2 className="text-2xl font-bold">User Growth</h2>

    <select
        value={selectedYear}
       onChange={(e) => {
  const y = Number(e.target.value);
  setSelectedYear(y);
  fetchDashboardData(y); // now safe because fetch uses the param
}}
        className="px-3 py-2 bg-white border-2 border-gray-200 rounded-lg text-[var(--black-text)]"
    >
        {years.map((yr) => (
            <option key={yr} value={yr}>
                {yr}
            </option>
        ))}
    </select>
</div>

    
          <UserGrowthChart rawGrowth={userGrowth} selectedYear={selectedYear} />
        </div>

        {/* User Activity */}
        <div className="p-6 rounded-lg bg-white border-2 border-gray-200 shadow-sm">
          <h2 className="text-2xl font-bold mb-4">User Activity</h2>

          <div className="space-y-2">
            <div className="flex justify-between">
              <span>Active Users Today</span>
              <span className="text-2xl font-bold">{stats.activeUsers}</span>
            </div>

            <div className="flex justify-between">
              <span>Total Users</span>
              <span className="text-2xl font-bold">{stats.totalUsers}</span>
            </div>

            <div className="flex justify-between">
              <span>New Users This Month</span>
              <span className="text-2xl font-bold">+{stats.newUsersThisMonth}</span>
            </div>
          </div>
        </div>
      </div>

      {/* RECENT USERS */}
      <div className="mt-10 p-6 rounded-lg bg-white border-2 border-gray-200 shadow-sm">
        <div className="flex justify-between mb-4">
          <h2 className="text-xl font-bold">Recent Users</h2>


        </div>

        <table className="w-full">
          <thead>
            <tr className="text-left border-b border-gray-200">
              <th className="pb-3">USER</th>
              <th className="pb-3">STATUS</th>
              <th className="pb-3">JOINED</th>
              <th className="pb-3">Gender</th>
            </tr>
          </thead>

          <tbody>
            {filteredUsers.map((user) => (
              <tr key={user._id} className="border-b border-gray-200">
                <td className="py-3 flex items-center gap-3">
                  <div className="w-10 h-10 bg-[var(--yellow)] text-white rounded-full flex items-center justify-center">
                    <FiUsers />
                  </div>
                  <div>
                    <p className="font-bold">{user.fullName}</p>
                    <p className="text-xs opacity-70">{user.phoneNumber}</p>
                  </div>
                </td>

                <td>
                  <span
                    className={`px-2 py-1 rounded text-xs font-medium ${user.isActive
                        ? "bg-[var(--yellow)] text-white"
                        : "bg-red-500 text-white"
                      }`}
                  >
                    {user.isActive ? "Active" : "Inactive"}
                  </span>
                </td>

                <td>{new Date(user.createdAt).toLocaleDateString()}</td>
                <td>{user.gender}</td>


              </tr>
            ))}
          </tbody>
        </table>
      </div>

    </div>
  );
}
